import type { Locale } from "./i18n/index.ts";

/**
 * « Récap » : résumé sans spoiler de ce que le lecteur a lu, jusqu'au chapitre en cours et pas au-delà.
 * Repris de Studio (dépôt ai, `nextjs/src/reader/summary.ts`) : posé au chat avec les mots du lecteur,
 * en nommant le chapitre en cours pour que la réponse s'arrête avant lui.
 */
export function spoilerFreeSummaryQuestion(section: string | undefined, locale: Locale): string {
  const chapter = section?.trim() ?? "";
  return locale === "en"
    ? `Give me the recap of everything before${chapter ? ` “${chapter}”` : " where I am"}.`
    : `Fais-moi le récap de tout ce qui précède${chapter ? ` « ${chapter} »` : ""}.`;
}

/**
 * Rang du chapitre en cours, compté comme ChatNovel : les chapitres sont les fichiers titrés de l'ordre de lecture
 * (un titre partagé par plusieurs fichiers compte une fois) ; un livre sans aucun titre compte ses fichiers. 0 si inconnu.
 */
export function chapterRank(titles: (string | undefined)[], index: number): number {
  if (index < 0) return 0;
  if (!titles.some((title) => title?.trim())) return index + 1;
  return new Set(titles.slice(0, index + 1).map((title) => title?.trim()).filter(Boolean)).size;
}

/** Le chapitre à partir duquel le back-office propose le récap (2 par défaut, comme Studio). */
export const DEFAULT_SUMMARY_MIN_CHAPTER = 2;

/** Le récap est proposé : permis pour ce livre, et le lecteur a dépassé le premier chapitre (ou celui que fixe le back-office). */
export function recapAvailable(allowed: boolean, chapter: number, minChapter: number | null | undefined): boolean {
  return allowed && chapter > 0 && chapter >= (minChapter ?? DEFAULT_SUMMARY_MIN_CHAPTER);
}
